import React from 'react';
import { StarIcon } from 'lucide-react';
const CART_URL = 'https://instanthandbook.com/en/cart/add?id=44085498708019&quantity=1';
export function HeroSection() {
  return <section className="pt-6 pb-5 md:pt-14 md:pb-14 bg-cream" data-id="element-134">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-135">
        {/* Tag */}
        <p className="text-gold font-semibold text-sm uppercase tracking-[0.2em] mb-3 md:mb-5 text-center" data-id="element-136">
          ✦ Natural Health Revolution ✦
        </p>

        {/* 1. Headline */}
        <h1 className="font-heading text-dark mb-3 md:mb-5 text-center leading-[1.08]" data-id="element-137">
          <span className="block text-primary text-lg md:text-2xl font-bold tracking-[0.15em] uppercase mb-2 md:mb-3" data-id="element-138">
            Finally:
          </span>
          <span className="block text-4xl md:text-6xl lg:text-7xl font-black mb-1 md:mb-2" data-id="element-139">
            A Complete
          </span>
          <span className="block text-[2.6rem] md:text-7xl lg:text-8xl font-black mb-1 md:mb-2 text-solution relative whitespace-nowrap" data-id="element-140">
            <span className="relative z-10" data-id="element-141">Natural Remedy</span>
            <span className="absolute bottom-1 md:bottom-2 left-1/2 -translate-x-1/2 w-[105%] h-2.5 md:h-3.5 bg-solution/15 -skew-x-3 z-0" data-id="element-142"></span>
          </span>
          <span className="block text-4xl md:text-6xl lg:text-7xl font-black mb-1 md:mb-2" data-id="element-143">
            System For{' '}
            <span className="relative inline-block" data-id="element-144">
              <span className="relative z-10" data-id="element-145">Every Symptom</span>
              <span className="absolute bottom-1 md:bottom-2 left-0 w-full h-2 md:h-3 bg-gold/30 -skew-x-3 z-0" data-id="element-146"></span>
            </span>
          </span>
          <span className="block text-2xl md:text-3xl lg:text-4xl font-medium text-dark/60 mt-2 md:mt-3" data-id="element-147">
            Your Family Will Ever Face.
          </span>
        </h1>

        {/* Decorative divider */}
        <div className="flex items-center justify-center gap-3 mb-3 md:mb-5" data-id="element-148">
          <div className="h-px w-12 bg-gold/40" data-id="element-149"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-150"></div>
          <div className="h-px w-12 bg-gold/40" data-id="element-151"></div>
        </div>

        {/* 2. Subheadline */}
        <p className="text-lg md:text-xl text-dark/60 font-normal mb-3 md:mb-4 leading-relaxed text-center tracking-wide" data-id="element-152">
          Discover the 300 ancient remedies that{' '}
          <span className="font-black text-dark" data-id="element-153">Big Pharma</span> has spent
          decades making sure{' '}
          <em className="italic font-medium text-dark/80" data-id="element-154">you'd never find</em>.
        </p>

        {/* Body copy */}

        {/* Hero Image */}
        <div className="relative mb-4 md:mb-6 max-w-lg mx-auto" data-id="element-155">
          <div className="bg-white rounded-2xl shadow-2xl p-2 border-2 border-gold-light overflow-hidden" data-id="element-156">
            <img src="https://cdn.magicpatterns.com/uploads/mzB7MBgKfmBr9ac6v72AeJ/portada_recetario_herbal_(1).jpg" alt="Woman preparing natural remedies in her kitchen with The Home Healing Handbook open" className="w-full rounded-xl object-cover aspect-[3/4]" loading="eager" data-id="element-157" />
          </div>
          <div className="absolute -bottom-3 -right-3 md:-bottom-4 md:-right-4 bg-pain text-white font-bold px-5 py-2.5 rounded-full shadow-lg transform rotate-6 text-sm md:text-base" data-id="element-158">
            72% OFF
          </div>
        </div>

        {/* 3. Checkmark Bullets */}
        <div className="space-y-1.5 mb-4 md:mb-6 max-w-xl mx-auto" data-id="element-159">
          <div className="flex items-center gap-3" data-id="element-160">
            <span className="text-solution text-xl" data-id="element-161">✅</span>
            <span className="text-dark font-medium" data-id="element-162">
              300+ Remedies Organized by Symptom
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-163">
            <span className="text-solution text-xl" data-id="element-164">✅</span>
            <span className="text-dark font-medium" data-id="element-165">
              Full Family Coverage — Adults, Kids & Hormonal Health
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-166">
            <span className="text-solution text-xl" data-id="element-167">✅</span>
            <span className="text-dark font-medium" data-id="element-168">
              Exact Dosages, Prep Times & Substitutes Included
            </span>
          </div>
        </div>

        {/* 4. Stars + Trust */}
        <div className="flex items-center justify-center gap-2 mb-4 md:mb-6" data-id="element-169">
          <div className="flex" data-id="element-170">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-171" />)}
          </div>
          <span className="text-muted text-sm" data-id="element-172">Trusted by 3,758+ families</span>
        </div>

        {/* 5. CTA Button */}
        <a href="https://instanthandbook.com/en/cart/add?id=44085498708019&quantity=1" className="block w-full bg-primary hover:bg-primary-light text-white font-bold text-lg md:text-xl px-8 py-5 rounded-lg transition-all duration-200 transform hover:scale-[1.01] shadow-lg hover:shadow-xl text-center" data-id="element-173">
          GIVE ME INSTANT ACCESS »
        </a>

        {/* 6. Price + Micro-copy */}

        <p className="text-muted text-sm mt-1 text-center" data-id="element-174">
          Your plan B for the next time someone in your house gets sick — ready
          in 2 minutes.
        </p>
      </div>
    </section>;
}